import { Job } from "@/lib/schema";
import locationIcon from "@/assets/jobs/icon_location.svg";
import { AlertTriangle } from "lucide-react";

interface JobInfoSectionProps {
  job: Job;
}

export function JobInfoSection({ job }: JobInfoSectionProps) {
  return (
    <div className="lg:w-2/5 bg-gradient-to-br from-orange-500/5 to-slate-100/50 p-6 lg:p-8 lg:border-r border-orange-100/30 lg:flex-shrink-0">
      <div className="text-center lg:text-left space-y-4 mb-6">
        <h1 className="text-2xl lg:text-3xl font-bold text-slate-800">
          Submit a Referral
        </h1>
        <p className="text-slate-600 font-medium text-sm lg:text-base">
          Help us find great talent and earn rewards for successful placements
        </p>
      </div>

      {/* Job Information */}
      <div className="bg-gradient-to-r from-slate-50/50 to-gray-50/50 rounded-xl p-8 border border-slate-200/50 backdrop-blur-sm shadow-sm">
        <div className="space-y-4">
          <div>
            <h4 className="font-bold text-slate-900 text-xl space-grotesk mb-3">{job.title}</h4>
            {/* Company name hidden for privacy */}
            <div className="flex items-center text-slate-600">
              <img src={locationIcon} alt="Location" className="h-4 w-4 mr-2" />
              <span className="font-medium">{job.location}</span>
            </div>
          </div>

          {/* Important Notes - Critical visibility before referral */}
          {job.importantNotes && (
            <div className="flex items-start gap-3 p-3 bg-amber-50 border border-amber-200 rounded-lg">
              <AlertTriangle className="w-4 h-4 text-amber-500 flex-shrink-0 mt-0.5" />
              <div>
                <h5 className="text-xs font-medium text-amber-800 space-grotesk uppercase tracking-wide mb-1">
                  Important Requirements
                </h5>
                <p className="text-xs text-slate-700 whitespace-pre-line font-manrope">
                  {job.importantNotes}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Benefits Section */}
      <div className="mt-6 space-y-3">
        <h4 className="font-bold text-slate-800 text-sm uppercase tracking-wide">Why Refer?</h4>
        <div className="space-y-2 text-sm">
          <div className="flex items-center space-x-3 text-slate-600">
            <div className="w-2 h-2 bg-orange-400 rounded-full flex-shrink-0"></div>
            <span>Earn rewards for successful hires</span>
          </div>
          <div className="flex items-center space-x-3 text-slate-600">
            <div className="w-2 h-2 bg-orange-400 rounded-full flex-shrink-0"></div>
            <span>Help talented people find great opportunities</span>
          </div>
          <div className="flex items-center space-x-3 text-slate-600">
            <div className="w-2 h-2 bg-orange-400 rounded-full flex-shrink-0"></div>
            <span>Quick and easy referral process</span>
          </div>
        </div>
      </div>
    </div>
  );
}
